/*
 PrzechowywanieDanych

 Tresc polityki prywatnosci Sposób i czas przechowywania danych dla wszystkich aplikacji 
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { Typography } from '@material-ui/core';

interface PrzechowywanieDanychProps {
    sms?: boolean
}

class PrzechowywanieDanych extends React.Component<PrzechowywanieDanychProps, any> {

    //PM 2021-11-05
    //variant='body2'
    //poprawka DOM
    render() {

        return (
            <React.Fragment>
                <Typography variant='body2'><b>Sposób i czas przechowywania danych</b></Typography>
                {this.props.sms ?
                    (
                        <Typography variant='body2'>
                            Dane zbierane przez aplikację są przechowywanie lokalnie na urządzeniach mobilnych użytkowników oraz skrzynce e-mailowej administratora danych gdy wysłany zostanie raport o awarii. Aplikacja wysyła również okresowe raporty dotyczące rozpoznanych fraz z otrzymanych wiadomości przetworzonych przez algorytm generujący automatyczne odpowiedzi i przekierowania. Twoje dane są przetwarzane do czasu istnienia podstawy ich przetwarzania tj. do czasu ustania uzasadnionego interesu administratora np. naprawienia usterki związanej z danym raportem awarii lub zgłoszenia chęci usunięcia danych przez użytkownika.
                        </Typography>
                    )
                    :
                    (
                        <Typography variant='body2'>
                            Dane zbierane przez aplikację są przechowywanie lokalnie na urządzeniach mobilnych użytkowników oraz skrzynce e-mailowej administratora danych gdy wysłany zostanie raport o awarii. Twoje dane są przetwarzane do czasu istnienia podstawy ich przetwarzania tj. do czasu ustania uzasadnionego interesu administratora np. naprawienia usterki związanej z danym raportem awarii lub zgłoszenia chęci usunięcia danych przez użytkownika.
                        </Typography>
                    )}
            </React.Fragment>
        );
    }
}

export default PrzechowywanieDanych;
